import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import ListTimelineTable from "@/components/app/ListTimelineTable.vue";
import CreateTimelineForm from "@/components/app/CreateTimelineForm.vue";
import {ref} from "vue";

// Define component properties

export default /*#__PURE__*/_defineComponent({
  __name: 'DashboardView',
  setup(__props) {

const createTimelineForm = ref<any>(null)

// Define methods
function itemCreatedHandler(row: any) {
  createTimelineForm.value.reloadTable()
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(CreateTimelineForm, { onItemCreated: itemCreatedHandler }),
    _createVNode(ListTimelineTable, {
      ref_key: "createTimelineForm",
      ref: createTimelineForm
    }, null, 512)
  ], 64))
}
}

})